var formatTime;

import {
  hexToRgb
} from 'helpers/colors';

import colors from 'constants/colors';

formatTime = function(date) {
  return moment(date).format('H:mm');
};

angular.module('gym.contacts').controller('EventSelectCtrl', ["$stateParams", "loadingAnimation", "$scope", "$modalInstance", "$http", "$filter", "ContrastColor", function($stateParams, loadingAnimation, $scope, $modalInstance, $http, $filter, ContrastColor) {
  var defaultView, setDefaultDate;
  defaultView = 'month';
  $scope.eventSources = [
    {
      events: function(start,
    end,
    callback) {
        var endDate,
    params,
    startDate;
        setDefaultDate(start);
        startDate = moment(start).subtract(1,
    'days').format('X');
        endDate = moment(end).add(1,
    'days').format('X');
        params = {
          view: 'contact_profile',
          start: startDate,
          end: endDate,
          '_': new Date().getTime()
        };
        return $http.get(`gyms/${$stateParams.gymId}/calendar/data`,
    {
          params: params
        }).then(function(response) {
          var events;
          events = response.data.map(function(item) {
            item.title = $filter('limitString')(item.title,
    50);
            item.color = item.color || colors.primary;
            item.textColor = ContrastColor.get(item.color,
    {
              darkColor: '#303030'
            });
            return item;
          });
          return callback(events);
        });
      }
    }
  ];
  $scope.uiConfig = {
    calendar: {
      header: null,
      editable: false,
      allDayDefault: false,
      allDaySlot: false,
      lazyFetching: false,
      defaultView: defaultView,
      firstDay: $scope.gym.gym_booking_detail.calendar_start_wday,
      firstHour: 9,
      eventAfterAllRender: function(view) {
        return $scope.calendarView = view;
      },
      eventClick: function(event) {
        return $modalInstance.close(event);
      },
      dayClick: function(date, allDay, event, sourceView) {
        var calendar;
        calendar = $('#calendar');
        calendar.fullCalendar('changeView', 'agendaDay');
        return calendar.fullCalendar('gotoDate', date);
      },
      eventRender: function(event, element, view) {
        var bgColor, rgb, time;
        rgb = hexToRgb(event.color) || hexToRgb(colors.primary);
        bgColor = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
        element.css('border', {
          'min-height': '29px'
        });
        element.find('.fc-event-inner').css({
          'background-color': bgColor
        });
        time = `${formatTime(event.start)} - ${formatTime(event.end)}`;
        element.find('.fc-event-time').text(time);
        if (!element.find('.fc-event-title').length) {
          element.find('.fc-event-inner').append(`<div class='fc-event-title'>${event.title}</div>`);
        }
        if (moment(event.end).diff(event.start, 'hours') < 1 && view.name !== 'month') {
          return element.find('.fc-event-time').remove();
        }
      },
      loading: function(isLoading) {
        if (isLoading) {
          return loadingAnimation.show();
        } else {
          return loadingAnimation.hide();
        }
      }
    }
  };
  $scope.currentView = function() {
    var ref;
    return (ref = $scope.calendarView) != null ? ref.calendar.getView() : void 0;
  };
  $scope.currentViewName = function() {
    var ref;
    return ((ref = $scope.currentView()) != null ? ref.name : void 0) || defaultView;
  };
  setDefaultDate = function(date) {
    var calendarView, momentDate, ref;
    calendarView = ((ref = $scope.currentView()) != null ? ref.name : void 0) || defaultView;
    $scope.calendarViewName = (function() {
      switch (calendarView) {
        case 'month':
          return 'month';
        case 'agendaWeek':
          return 'week';
        case 'agendaDay':
          return 'day';
        case 'basicDay':
          return 'day';
      }
    })();
    return $scope.startDate = momentDate = calendarView === 'month' ? moment(date).add(2, 'w') : moment(date);
  };
  $scope.toDate = function(date) {
    return $scope.calendarView.calendar.gotoDate(date.toDate());
  };
  $scope.getTitle = function() {
    var ref, title;
    title = (ref = $scope.calendarView) != null ? ref.title : void 0;
    if (title) {
      return title.replace('&#8212;', '—');
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
